{
  "PROFILE_SETTINGS": {
    "LINK": "Stillingar Prófíls",
    "TITLE": "Stillingar Prófíls",
    "BTN_TEXT": "Uppfæra Prófíl",
    "DELETE_AVATAR": "Eyða mynd",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "Villa kom upp við að eyða notendamynd, vinsamlegast reyndu aftur",
    "UPDATE_SUCCESS": "Prófíllinn þinn hefur verið uppfærður",
    "PASSWORD_UPDATE_SUCCESS": "Lykilorðinu þínu hefur verið breytt",
    "AFTER_EMAIL_CHANGED": "Prófíllinn þinn hefur verið uppfærður, vinsamlegast skráðu þig inn aftur þar sem innskráningarskilríkjum þínum er breytt",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Mynd fyrir tölvupóstundirskrift",
        "HINT": "Notuð í tölvupóstundirskriftum. {'{{'}email_signature_picture{'}}'} er skipt út fyrir vefslóð þessarar myndar (ekki img-tag) — notaðu hana sem myndheimild (src í img-tagi) í undirskriftinni þinni eða undirskrift pósthólfsins. Ef hún er ekki stillt er engu bætt við.",
        "DELETE_SUCCESS": "Mynd fyrir tölvupóstundirskrift hefur verið eytt",
        "DELETE_FAILED": "Villa kom upp við að eyða mynd fyrir tölvupóstundirskrift, reyndu aftur"
      },
      "AVATAR": "Prófílmynd",
      "ERROR": "Vinsamlegast lagfærðu villurnar",
      "REMOVE_IMAGE": "Fjarlægja",
      "UPLOAD_IMAGE": "Hlaða upp mynd",
      "UPDATE_IMAGE": "Uppfæra mynd",
      "PROFILE_SECTION": {
        "TITLE": "Prófíll",
        "NOTE": "Netfangið þitt er auðkenni þitt og er notað til að skrá þig inn."
      },
      "SEND_MESSAGE": {
        "TITLE": "Flýtilykill til að senda skilaboð",
        "NOTE": "Þú getur valið flýtilykil (annaðhvort Enter eða Cmd/Ctrl+Enter) eftir því hvernig þú vilt skrifa.",
        "UPDATE_SUCCESS": "Stillingar þínar hafa verið uppfærðar",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Sendu skilaboð með því að ýta á Enter takkann í stað þess að smella á senda takkann."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Sendu skilaboð með því að ýta á Cmd/Ctrl + enter takkann í stað þess að smella á senda takkann."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Sérsníddu útlit og viðmót mælaborðsins þíns.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Tungumál mælaborðs",
          "NOTE": "Yfirskrifa tungumál reikningsins fyrir þitt eigið mælaborð. Skildu eftir autt til að nota sjálfgefið tungumál reikningsins.",
          "USE_ACCOUNT_DEFAULT": "Nota sjálfgefið tungumál reiknings",
          "API_SUCCESS": "Tungumál mælaborðsins þíns hefur verið uppfært"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Tungumál skilaboða",
          "NOTE": "Veldu hvort birta eigi upprunaleg skilaboð eða þýðingar þeirra",
          "ORIGINAL": "Upprunalegt",
          "TRANSLATED": "Þýtt"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Hegðun við að líma",
          "NOTE": "Veldu hvernig límt efni er unnið þegar skilaboð eru samin",
          "UPDATE_SUCCESS": "Stillingar þínar fyrir að líma hafa verið uppfærðar",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Halda allri sniðsetningu",
              "DESCRIPTION": "Haltu allri sniðsetningu, þar á meðal töflum, stílum og öðrum HTML-einingum, þegar efni er límt."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Aðeins texti og tenglar",
              "DESCRIPTION": "Umbreyta í hreinan texta en halda smellanlegum tenglum þegar efni er límt."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Aðeins hreinn texti",
              "DESCRIPTION": "Fjarlægja alla sniðsetningu og umbreyta í hreinan texta þegar efni er límt."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Hæð svarreits",
          "NOTE": "Stilltu lágmarkshæð svarreitsins sem hlutfall af skjáhæð. Á aðeins við um tölvupóstsamtöl.",
          "UPDATE_SUCCESS": "Stillingin fyrir hæð svarreits hefur verið uppfærð",
          "PERCENT_LABEL": "Hæð (% af skjáhæð)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Sjálfgefið",
              "DESCRIPTION": "Svarreiturinn byrjar lítill og stækkar eftir því sem þú skrifar."
            },
            "CUSTOM": {
              "HEADING": "Sérsniðið",
              "DESCRIPTION": "Svarreiturinn er alltaf að minnsta kosti valið hlutfall af skjáhæð."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Fara sjálfkrafa í næsta samtal",
        "NOTE": "Skipta sjálfkrafa yfir í næsta opna samtal eftir að núverandi samtali hefur verið lokað",
        "UPDATE_SUCCESS": "Stilling fyrir sjálfvirka leiðsögn hefur verið uppfærð"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Persónuleg undirskrift á skilaboðum",
        "DESCRIPTION": "Búðu til einstaka undirskrift sem birtist neðst í hverjum tölvupósti sem þú sendir. Þú getur einnig bætt við mynd.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Vista undirskrift á skilaboðum",
        "API_ERROR": "Gat ekki vistað undirskrift! Reyndu aftur",
        "API_SUCCESS": "Undirskrift var vistuð",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Undirskrift skilaboða",
        "ERROR": "Undirskrift skilaboða getur ekki verið tóm",
        "PLACEHOLDER": "Settu inn persónulegu skilaboðaundirskriftina þína hér."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Lykilorð",
        "NOTE": "Að uppfæra lykilorðið þitt myndi endurstilla innskráningar þínar í mörgum tækjum.",
        "BTN_TEXT": "Breyta lykilorði"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Aðgangslykill",
        "NOTE": "Þetta token er hægt að nota ef þú ert að byggja upp API byggða samþættingu",
        "COPY": "Afrita",
        "REGENERATE": "Búa til á ný",
        "REGENERATE_SUCCESS": "Aðgangslykill var búinn til á ný. Vinsamlegast uppfærðu allar samþættingar sem nota gamla lykilinn.",
        "REGENERATE_CONFIRM_TITLE": "Búa til aðgangslykil á ný?",
        "REGENERATE_CONFIRM_MESSAGE": "Þetta ógildir núverandi lykil. Samþættingar sem nota gamla lykilinn hætta að virka."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-viðbót",
        "NOTE": "Settu upp Chrome-viðbótina okkar til að fá ítarlegar tilkynningar um innhringd símtöl.",
        "INSTALL_BUTTON": "Setja upp viðbót",
        "ALREADY_INSTALLED": "Viðbót uppsett"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Enginn",
          "MINE": "Assigned",
          "ALL": "Allt",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Enginn",
          "ASSIGNED": "Úthlutuð Samtöl",
          "ALL_CONVERSATIONS": "Öll Samtöl"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Senda hljóðviðvaranir aðeins ef vafraglugginn er ekki virkur",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Tilkynningar í tölvupósti",
        "NOTE": "Uppfærðu stillingar þínar fyrir tölvupósttilkynningar hér",
        "CONVERSATION_ASSIGNMENT": "Senda tilkynningar í tölvupósti þegar mér er úthlutað samtali",
        "CONVERSATION_CREATION": "Senda tilkynningar í tölvupósti þegar nýtt samtal er stofnað",
        "CONVERSATION_MENTION": "Sendu tilkynningar í tölvupósti þegar minnst er á þig í samtali",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Sendu tilkynningar í tölvupósti þegar ný skilaboð eru búin til í úthlutuðu samtali",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Tölvupóstfang",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Ný skilaboð berast í samtali án tiltæks þjónustufulltrúa",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Leyfa ýti-tilkynningar meðan þú ert í símtali",
        "TEST_PUSH": "Prófa",
        "TESTING": "Prófa...",
        "TEST_PUSH_DESCRIPTION": "Sendu prufu-tilkynningar til að staðfesta uppsetninguna þína",
        "TEST_NOTIFICATION_ERROR": "Ekki tókst að senda prufu-tilkynningu. Vinsamlegast reyndu aftur.",
        "TEST_LOCAL_TITLE": "Prufu-tilkynning (staðbundin)",
        "TEST_LOCAL_BODY": "Þetta er staðbundin vafratilkynning. Ef þú sérð þetta virka vafratilkynningar!"
      },
      "API": {
        "UPDATE_SUCCESS": "Tilkynningarstillingarnar þínar hafa verið uppfærðar",
        "UPDATE_ERROR": "Villa kom upp við að uppfæra stillingarnar, vinsamlegast reyndu aftur"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Notifications",
        "NOTE": "Uppfærðu stillingar þínar fyrir þrýstitilkynningar hér",
        "CONVERSATION_ASSIGNMENT": "Senda þrýstitilkynningar þegar mér er úthlutað samtali",
        "CONVERSATION_CREATION": "Senda þrýstitilkynningar þegar nýtt samtal er stofnað",
        "CONVERSATION_MENTION": "Sendu þrýstitilkynningar þegar minnst er á þig í samtali",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Sendu push tilkynningar þegar ný skilaboð eru búin til í úthlutuðu samtali",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "You have enabled push for this browser.",
        "REQUEST_PUSH": "Enable push notifications",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Prófílmynd"
      },
      "NAME": {
        "LABEL": "Your full name",
        "ERROR": "Vinsamlegast skrifaðu gilt nafn",
        "PLACEHOLDER": "Vinsamlegast sláðu inn nafnið þitt"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display name",
        "ERROR": "Please enter a valid display name",
        "PLACEHOLDER": "Vinsamlegast sláðu inn birtingarnafn, þetta birtist í samtölum"
      },
      "POSITION": {
        "LABEL": "Staða",
        "ERROR": "Vinsamlegast sláðu inn gilda stöðu",
        "PLACEHOLDER": "Vinsamlegast sláðu inn stöðu þína"
      },
      "CUSTOM_LINE": {
        "LABEL": "Sérsniðin lína",
        "ERROR": "Vinsamlegast sláðu inn gilda sérsniðna línu",
        "PLACEHOLDER": "Vinsamlegast sláðu inn sérsniðnu línuna þína"
      },
      "AVAILABILITY": {
        "LABEL": "Availability",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Upptekinn",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Snið á forskoðun tölvupósts í samtalalistanum",
        "NOTE": "Veldu hvað birtist í samtalalistanum fyrir samtöl úr tölvupóstshólfum",
        "SUBJECT": "Efni",
        "SUBJECT_WITH_NOTE": "Efni og síðustu skilaboðin, ef um innri glósu er að ræða",
        "UPDATE_SUCCESS": "Stillingar fyrir forskoðun tölvupósts hafa verið uppfærðar"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Slökkva á flýtilyklum",
        "NOTE": "Slökkva á öllum flýtilyklum í öllu forritinu",
        "UPDATE_SUCCESS": "Stilling flýtilykla hefur verið uppfærð"
      },
      "FOLDER_ORDER": {
        "TITLE": "Röð mappa",
        "NOTE": "Sérsníddu röðina sem möppur (sérsniðnar sýnir) birtast í hliðarstikunni. Dragðu og slepptu til að endurraða.",
        "NO_FOLDERS": "Engar sérsniðnar möppur fundust. Stofnaðu möppur til að skipuleggja samtölin þín."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Stillingar hliðarstiku",
        "NOTE": "Sérsníddu hvaða hlutar birtast í hliðarstiku samtala.",
        "SAVE_BUTTON": "Vista stillingar",
        "UPDATE_SUCCESS": "Stillingar hliðarstiku hafa verið uppfærðar",
        "UPDATE_ERROR": "Villa kom upp við að uppfæra stillingar hliðarstiku, vinsamlegast reyndu aftur",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Öll samtöl",
          "ALL_CONVERSATIONS_DESC": "Sýna valmyndaratriðið Öll samtöl í hliðarstikunni",
          "INBOX": "Innhólf",
          "INBOX_DESC": "Sýna aðalinnhólfið með ólesnum tilkynningum",
          "CONVERSATION_GROUPS": "Nefnt og óafgreitt",
          "CONVERSATION_GROUPS_DESC": "Sýna hópana Nefnt og Óafgreitt",
          "FOLDERS": "Möppur",
          "FOLDERS_DESC": "Sýna sérsniðnar sýnir (möppur) fyrir skipulögð samtöl",
          "TEAMS": "Teymi",
          "TEAMS_DESC": "Sýna samtöl síuð eftir úthlutun til teyma",
          "CHANNELS": "Innhólf",
          "CHANNELS_DESC": "Sýna samtöl síuð eftir innhólfi",
          "LABELS": "Merkingar",
          "LABELS_DESC": "Sýna samtöl síuð eftir merkingum"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Símastillingar",
        "NOTE": "Sláðu inn innskráningarupplýsingar fyrir símstöðina þína.",
        "USERNAME": "Notandanafn",
        "PASSWORD": "Lykilorð",
        "SUBMIT": "Vista",
        "USERNAME_INVALID": "Notandanafnið má aðeins innihalda bókstafi, tölustafi og . _ - + — engin bil og ekkert netfang.",
        "API": {
          "USERNAME_INVALID": "Notandanafnið er ekki gilt SIP notandanafn. Notaðu aðeins bókstafi, tölustafi og . _ - + — engin bil og ekkert netfang.",
          "USERNAME_TAKEN": "Þetta notandanafn er þegar í notkun hjá öðrum þjónustufulltrúa á þessum reikningi."
        }
      },
      "EMAIL": {
        "LABEL": "Þitt tölvupóstfang",
        "ERROR": "Vinsamlegast skrifaðu gilt netfang",
        "PLACEHOLDER": "Vinsamlegast sláðu inn netfangið þitt, þetta myndi birtast í samtölum"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Núverandi lykilorð",
        "ERROR": "Vinsamlegast sláðu inn núverandi lykilorð",
        "PLACEHOLDER": "Vinsamlegast sláðu inn núverandi lykilorð"
      },
      "PASSWORD": {
        "LABEL": "Nýtt lykilorð",
        "ERROR": "Vinsamlegast sláðu inn lykilorð 6 stafa lengd eða meira",
        "PLACEHOLDER": "Vinsamlegast sláðu inn nýja lykilorðið"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Staðfesta nýtt lykilorð",
        "ERROR": "Staðfest lykilorð ætti að passa við lykilorðið",
        "PLACEHOLDER": "Vinsamlegasts staðfestu nýja lykilorðið"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Breyta",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Tilkynna villu",
    "SELECTOR_SUBTITLE": "Veldu reikning úr eftirfarandi lista",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Tilkynna villu",
    "DESCRIPTION_LABEL": "Lýsing á vandamáli",
    "DESCRIPTION_PLACEHOLDER": "Lýstu vandamálinu sem þú lentir í...",
    "SUBMIT": "Senda tilkynningu",
    "SUBMITTING": "Sendi...",
    "CANCEL": "Hætta við",
    "SUCCESS": "Villutilkynning send. Takk fyrir!",
    "VALIDATION_ERROR": "Vinsamlegast lýstu vandamálinu áður en þú sendir"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "days trial remaining.",
    "TRAIL_BUTTON": "Buy Now",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Reikningnum þínum er lokað. Vinsamlegast hafðu samband við þjónustusviðið okkar til að fá frekari upplýsingar."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copy",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Code copied to clipboard successfully"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Sækja",
      "UPLOADING": "Hleður upp...",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "RECORDING_UNAVAILABLE": "Þessi upptaka er ekki lengur tiltæk.",
      "DELETE_RECORDING": {
        "BUTTON": "Eyða símtalaupptöku",
        "TITLE": "Eyða símtalaupptökunni?",
        "DESCRIPTION": "Öllum upptökum þessa símtals verður eytt varanlega úr símkerfinu og ekki er hægt að endurheimta þær. Uppskrift og samantekt símtalsins haldast.",
        "CONFIRM": "Eyða",
        "SUCCESS": "Símtalaupptöku eytt",
        "ERROR": "Ekki tókst að eyða símtalaupptökunni. Reyndu aftur."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Senda"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifying...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Add Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Samtöl",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Öll Samtöl",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Reports",
    "SETTINGS": "Stillingar",
    "CONTACTS": "Tengiliðir",
    "DATA_ASSISTANT": "Gagnaaðstoð",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Home",
    "AGENTS": "Þjónustufulltrúar",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Aðgerðaskrá",
    "WHATSAPP_TEMPLATES": "WhatsApp sniðmát",
    "BLOCKED_DOMAINS": "RUSLPÓSTUR",
    "INBOXES": "Innhólf",
    "NOTIFICATIONS": "Skilaboð",
    "CANNED_RESPONSES": "Stöðluð svör",
    "INTEGRATIONS": "Integrations",
    "PROFILE_SETTINGS": "Stillingar Prófíls",
    "ACCOUNT_SETTINGS": "Account Settings",
    "APPLICATIONS": "Applications",
    "LABELS": "Labels",
    "CUSTOM_ATTRIBUTES": "Custom Attributes",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Samtöl",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Herferð",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Þjónustufulltrúar",
    "REPORTS_LABEL": "Labels",
    "REPORTS_INBOX": "Innhólf",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Sími",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Yfirlit",
    "WALLBOARD_QUEUES": "Raðir",
    "DATA_ASSISTANT_CHAT": "Spjall",
    "DATA_ASSISTANT_REPORTS": "Skýrslur",
    "NO_WAITING_CALLERS": "engir hringjendur bíða",
    "WAITING_CALLERS": "{count} hringjendur bíða",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Læst á meðan þú ert skráð(ur) inn sem þessi notandi",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Nýtt samtal",
    "DRAFT": "Drög",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Stillingar",
      "DICTIONARY": "Orðabók"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Lokuð lén og tengiliðir",
    "DESCRIPTION": "Listi yfir lokuð tölvupóstslén fyrir þennan reikning.",
    "NO_BLOCKED_DOMAINS": "Engin lokuð lén fundust.",
    "BLOCKED_CONTACTS_BTN": "Lokaðir tengiliðir"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "Þú ert áskrifandi að **{plan}** áætluninni með **{quantity}** leyfi",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "Skoðaðu fyrri reikninga þína, breyttu innheimtuupplýsingum þínum eða sagði upp áskriftinni þinni.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Vantar þig aðstoð?",
      "DESCRIPTION": "Stendur þú frammi fyrir einhverjum vandamálum í innheimtu? Við erum hér til að hjálpa.",
      "BUTTON_TXT": "Spjallaðu við okkur"
    },
    "NO_BILLING_USER": "Verið er að stilla innheimtureikninginn þinn. Endurnýjaðu síðuna og reyndu aftur."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh ó! Við fundum enga reikninga. Vinsamlegast búðu til nýjan reikning til að halda áfram.",
    "NEW_ACCOUNT": "New Account",
    "SELECTOR_SUBTITLE": "Stofna nýjan aðgang",
    "API": {
      "SUCCESS_MESSAGE": "Account created successfully",
      "EXIST_MESSAGE": "Account already exists",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nafn fyrirtækis",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Senda",
      "CANCEL": "Hætta við"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Opna samtal",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "Gervigreindaraðstoð",
      "AI_ASSIST_GRAMMAR": "Laga málfræði",
      "AI_ASSIST_UNIFY_LANG": "Samræma tungumál skilaboða"
    }
  }
}
